
import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Table } from 'react-bootstrap';
import { DropDown, FieldGroup, TextInput, CurrencyInput, RadioButton, CheckBoxes } from '../../../../../../../../components/form/form';
import SellingAgentAllocation from './selling-agent-allocation/selling-agent-allocation';
import { PATTERN_ALPHA_NUMERIC_SPACE, PATTERN_ALPHA_NUMERIC_SPACE_DOT, PATTERN_NUMBER_4_DECIMAL } from '../../../../../../../../helpr/constants';

import styles from './issue-participant-form.module.scss';

const EditIssueParticipantForm = ({ index, securityList, participantFormState, participantRole, saveParticipant, cancelEdit, isEditable}) => {
  const { validate, getTextFieldProps, getRadioButtonProps, getCheckBoxesProps } = participantFormState;
  const securityIndexes = securityList.map((data,index)=>{return {name: data['prefShortName'], value: index.toString()}});
  const salutations = [ {name: 'Mr.', value: 'Mr.'}, {name: 'Ms.', value: 'Ms.'} ];

  const saveEdit = () => {
    const { isFormValid, formState } = validate();
    if( isFormValid ){
      /*
        Build Selling Agent Allocation 
      */
      if(formState['role'] === 'SellingAgent') {
        // Synchronize Security Indexes
        for(var i in formState['allocation']){
          formState['allocation'][i].id = securityList[parseInt(formState['allocation'][i].securityIndex)].id
        }
      }
      saveParticipant(index, formState)
    };
  }

  const renderActionButtons = () => {
    return (
      <Row className={styles['btn-actions']}>
        <Button className="btn-secondary" onClick={()=>cancelEdit(index)}>CANCEL</Button>
        <Button onClick={()=>saveEdit()}>SAVE</Button>
      </Row>
    )
  }

  return (
    <>
      <Row className="mt-2">
        <Col>
          <Row>
            <Col md="4">
              <TextInput inputProps={getTextFieldProps('institutionName')} disabled={!isEditable}>
                Institution Name:*
              </TextInput>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="8">
          <FieldGroup header="PRIMARY CONTACT NAME">
            <Row>
              <Col md="4">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('primaryContactLastName')} placeholder="Last Name" maxLength="75" pattern={PATTERN_ALPHA_NUMERIC_SPACE}/>
              </Col>
              <Col md="4">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('primaryContactFirstName')} placeholder="First Name" maxLength="70" pattern={PATTERN_ALPHA_NUMERIC_SPACE}/>
              </Col>
              <Col md="4">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('primaryContactMiddleInitial')} placeholder="Middle Initial" maxLength="3" pattern={PATTERN_ALPHA_NUMERIC_SPACE_DOT}/>
              </Col>
            </Row>
          </FieldGroup>
        </Col>
      </Row>
      <Row>
        <Col md="8">
          <Row>
            <Col md="6">
              <RadioButton disabled={!isEditable} inputProps={getRadioButtonProps('preferredSalutation')} data={salutations}>
                Preferred Salutation:*
              </RadioButton>
            </Col>
            <Col md="6">
              <TextInput disabled={!isEditable} inputProps={getTextFieldProps('title')} maxLength="150" pattern={PATTERN_ALPHA_NUMERIC_SPACE}>
                Title/Designation:*
              </TextInput>
            </Col>
          </Row>
        </Col>
      </Row>
      {participantRole === 'SellingAgent' && (
        <>
          <SellingAgentAllocation isEditable={isEditable}  securityList={securityList} participantFormState={participantFormState}/>
        </>
      )}
      {participantRole === 'MarketMaker' && (
        <>
          <Row>
            <Col>
              <CheckBoxes disabled={!isEditable} inputProps={getCheckBoxesProps('securitySubscription')} values={securityIndexes}>
                Security:*
              </CheckBoxes>
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col md="8">
          <FieldGroup header="MAILING ADDRESS:*">
            <Row>
              <Col>
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('addressStreetAddress')} placeholder="House/Lot/Block/Unit No., Floor & Building, Subdivision/Barangay/Vilage" maxLength="50"/>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('addressDistrictOrTown')} placeholder="District/Town" maxLength="50"/>
              </Col>
              <Col md="6">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('addressCity')} placeholder="City" maxLength="50"/>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('addressStateProvinceRegion')} placeholder="State/Province/Region" maxLength="50"/>
              </Col>
              <Col md="6">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('addressCountry')} placeholder="Country" maxLength="50"/>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <TextInput disabled={!isEditable} inputProps={getTextFieldProps('addressZipCode')} placeholder="Zip Code" maxLength="50"/>
              </Col>
            </Row>
          </FieldGroup>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col md="8">
          <Row>
            <Col md="6">
              <TextInput disabled={!isEditable}  inputProps={getTextFieldProps('telephoneNumber')} maxLength="30">
                Telephone Number:*
              </TextInput>
            </Col>
            <Col md="6">
              <TextInput disabled={!isEditable}  inputProps={getTextFieldProps('emailAddress')}>
                Email Address:*
              </TextInput>
            </Col>
          </Row>
        </Col>
      </Row>
      { renderActionButtons() }
    </>
  )
}

export default EditIssueParticipantForm;



